import './PlanOperatorFooter.scss';

import { OperatorLogo, ProductOffering } from '@travelwin/core';

import { CheckMarkIcon } from '@/components/PlanCard/components/CheckMarkIcon';

interface Props {
  planDetails: ProductOffering;
}

const PlanOperatorFooter = ({ planDetails }: Props) => {
  const className = 'c-PlanOperatorFooter';

  return (
    <div className={className}>
      <div className={`${className}__operator-icon`}>
        <OperatorLogo name={planDetails.icon_uri} />
      </div>
      {planDetails.promo_text && (
        <div className={`${className}__operator-promo-text`}>
          {planDetails.promo_text}
        </div>
      )}
      <div className={`${className}__operator-checkmark`}>
        <CheckMarkIcon />
      </div>
    </div>
  );
};

export default PlanOperatorFooter;
